var emotionUseInsertionEffectWithFallbacks_cjs_prod = {};

export { emotionUseInsertionEffectWithFallbacks_cjs_prod as __exports };
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.cjs.prod.js.map
